import { ResourceTypes } from './data';

export function getResourceUrl(type: number, id: string) {
  switch (type) {
    case ResourceTypes.Form:
      return `/forms/${id}`;
    case ResourceTypes.Template:
      return `/templates/${id}`;
    case ResourceTypes.DataSource:
      return `/datasource/edit?id=${id}`;
    case ResourceTypes.Workflow:
      return `/workflows/${id}`;
    case ResourceTypes.WorkflowJob:
      return `/workflows/jobs/${id}`;
    case ResourceTypes.App:
      return `/applications/${id}`;
    default:
      return null;
  }
}

export const handleTextStyleForTransfer = (notificationText: string) => {
  if (notificationText?.includes('transferred you a form')) {
    const textArray = notificationText.split('transferred you a form');
    return {
      boldText: textArray[0],
      normalText: textArray[1],
      hasTransferText: true
    };
  } else {
    return {
      text: notificationText,
      hasTransferText: false
    };
  }
};
